// eslint-disable-next-line no-unused-vars
export enum SortDirectionOptions {
  ascend = 'ASC',
  descend = 'DESC',
  none = 'NONE'
}
